import { ItemPrice } from "./calculateMarginsAndPricesPayload.model";
import { OrderExtraCost } from "./enquiry.model";

export class ExtraCostParametersValues {
    extraCosts?: ExtraCostParameter[];
}

export class ExtraCostParameter {
    extraCostId?: number;
    extraCostName?: string;
    extraCostMetricUoms?: string[];
    extraCostImperialUoms?: string[];
    isOrderExtraCost?: boolean;
}

export class ItemExtraCosts {
    itemExtraCosts?: ExtraCost[]
    orderExtraCost?: OrderExtraCost
}

export class ExtraCost {
    extraCostId?: number;
    extraCostName?: string;
    extraCostAmount?: number;
    extraCostUom?: string;
    numberOfTests?: number
}

export class UpdateItemsPriceAndDelivery {
    itemsPrice?: {
        itemNo: string,
        itemPrice: ItemPrice,
    }[];
    itemsDelivery?: {
        itemNo: string,
        extraLeadTime: number,
        deliveryNotes?: string | null,
    }[]
}